import React, { useState } from 'react';
import classNames from 'classnames';
import TextInput from './TextInput';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';

export default function TextPasswordInput(props) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <TextInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      // autocomplete="new-password"
      inputAfter={<Icons className={classNames('password-icon', showPassword ? 'eye-fill' : 'eye-slash-fill')} customIcon onClick={() => setShowPassword(!showPassword)} icon={showPassword ? 'eye-fill' : 'eye-slash-fill'} />}
    />
  );
}
